import { render, staticRenderFns } from "./Projects.container.vue?vue&type=template&id=6cf78080&scoped=true&"
import script from "./Projects.container.vue?vue&type=script&lang=js&"
export * from "./Projects.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf78080",
  null
  
)

export default component.exports